// ============================================================================
// KD TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'kd-tree',
  name: 'KD Tree',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) average, O(N) worst per query',
    space: 'O(N)'
  },
  description: 'A space-partitioning data structure for organizing points in k-dimensional space. Enables efficient nearest neighbor searches and range queries by recursively partitioning space along alternating dimensions.'
};
